import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useEffect, useMemo, useRef, useState } from "react";
import TerytService from "api/TerytService";
import { useDebounce } from "use-debounce";
import { useOnClickOutside } from "hooks/useClickOutside";
import { useTranslation } from "react-i18next";

const SearchPlace: FC<Props> = ({
  id,
  onBlur,
  isError = "",
  onChange,
  defaultValue,
  zipCode,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue.toString() ?? "");
  const [search, setSearch] = useState("");

  const [debouncedSearch] = useDebounce(search, 300);
  const [searchList, setSearchList] = useState<any[]>([]);

  const { data: cityData } = TerytService.useGetCity(
    debouncedSearch.length > 0 ? debouncedSearch : null,
    zipCode
  );
  const cities: any[] = useMemo(() => cityData?.data ?? [], [cityData]);

  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const list = cities.map((zip) => zip);

    setSearchList(list);

    if (list.length === 1) {
      setValue(list[0].Name);
      onChange(list[0].Name, list[0].Id);
    }
  }, [search, cities]);

  const handleClick = (zip: any) => {
    setValue(zip.Name);
    onChange(zip.Name, zip.Id);
    // setSearch('');
    setSearchList([]);
  };

  useEffect(() => {
    setValue(defaultValue.toString());
  }, [defaultValue]);

  useEffect(() => {
    if (zipCode) {
      setValue("");
      setSearch("");
    }
  }, [zipCode]);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (focused) {
      setFocused(false);
    }
  });

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <Input
        id={id}
        value={value}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          if (searchList && searchList.length === 1 && value.length) {
            handleClick(searchList[0]);
          }
          onBlur?.();
          setTimeout(() => {
            setFocused(false);
          }, 200);
        }}
        isError={isError}
        label={t("forms.city")}
        onChange={(text) => {
          setValue(text);
          setSearch(text);
        }}
        placeholder={t("forms.city")}
        inputProps={{
          "data-1p-ignore": "",
          "data-op-ignore": "",
        }}
      />
      {!!searchList.length && focused && (
        <div className={styles.list}>
          <div className={styles.listWrapper}>
            {searchList.map((zip: any) => (
              <div
                onClick={() => handleClick(zip)}
                key={"place" + zip.Id}
                className={styles.box}
              >
                {zip.Name} ({zip.District}, {zip.Voivodeship})
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPlace;
